<template lang="html">
	<div class="notice">
		<ul class="content">
			<li class="noticeTitle">拼团有什么规则呢？</li>
			<li class="notocrCon">
				<p class="dian"></p>
				<div class="text">本次拼团，参团者必须是电巢的新用户，而发团者既可以是老用户也可以是新用户。</div>
			</li>
			<li class="notocrCon">
				<p class="dian"></p>
				<div class="text">
					<p>必须在本次拼团有效期内完成拼团所需人数的条件，为拼团成功。</p><br>
					<p>例如，0元3人拼团课，有效期48小时，则需要在发起者发出该拼团后，
					48小时内邀请到两位电巢新用户参团，当前参团就成功啦。</p>
				</div>
			</li>
		</ul>
		
		<ul class="content">
			<li class="noticeTitle">什么是新用户？</li>
			<li class="notocrCon">
				<p class="dian"></p>
				<div class="text">新用户就是在拼团过程中，用户填写的电话号码是之前没有绑定和注册过的电巢平台的都视为新用户。</div>
			</li>
		</ul>
		
		<ul class="content">
			<li class="noticeTitle">我怎么知道我是新用户还是老用户？</li>
			<li class="notocrCon">
				<p class="dian"></p>
				<div class="text">您在拼团中，我们会为您生成您拼团使用的电话号码关联的订单，在此途中，我们会根据您拼团的电话号码是否已经存储于我们电巢账户中来区分您是新用户还是老用户，同时给出您及时的提示。</div>
			</li>
		</ul>
		
		<ul class="content">
			<li class="noticeTitle">我是电巢老用户，但是我之前并没有绑定电话，也没有使用电话登录注册过，那我是不是可以作为新用户参与拼团？？</li>
			<li class="notocrCon">
				<p class="dian"></p>
				<div class="text">本次拼团活动呢，我们只是根据您拼团填写的电话来为您制定拼团订单的；换言之，如果您是老用户，但您之前未曾在电巢平台绑定拼团所使用的电话号码或者使用这个电话登录注册过，您都可以作为新用户参团。</div>
			</li>
		</ul>
		
		<ul class="content">
			<li class="noticeTitle">那如果我是老用户，我如何在拼团中免费学课？</li>
			<li class="notocrCon">
				<p class="dian"></p>
				<div class="text">首先恭喜您是老用户，老用户享有的权益更多呢，可在<span>电巢APP</span>福利中心领取更多老用户的权益呢。但拼课中如果您是老用户，您也可以通过发起拼团，邀请新用户参团来免费学课啊。</div>
			</li>
		</ul>
		
		<ul class="content">
			<li class="noticeTitle">拼团成功的课程在哪里看呢？</li>
			<li class="notocrCon">
				<p class="dian"></p>
				<div class="text">您拼团成功之后，只需要使用拼团所登记的电话登录电巢APP，在我-订单里就可以找到这个拼团课了。需要注意的是：使用其他登录方式登录电巢APP，很可能找不到这个拼团订单呢。</div>
			</li>
		</ul>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				show: this.noticeShow,
			}
		},
		mounted() {
			document.title = '拼团须知'
		},
		methods: {
			// showClose() {
			// 	this.$emit("parEvn", false);
			// }
		},
	}
</script>

<style lang="css" scoped>
	.notice{
		box-sizing: border-box;
		padding: 0 1.5rem;
	}
	
	.content{
		box-sizing: border-box;
		padding: 2.4rem 0;
	}
	
	.noticeTitle{
		font-size: 1.6rem;
		font-weight: 600;
		color: #1D2023;
	}
	
	.notocrCon{
		margin-top: 2rem;
		font-size: 1.4rem;
		color: #3F454B;
		display: flex;
		justify-content: space-between;
		align-items: flex-start;
	}
	
	.dian {
		width: .6rem;
		height: .6rem;
		background-color: #606972;
		margin-top: .8rem;
		border-radius: 50%;
	}
	
	.text{
		width: 96%;
	}
	
	.text span {
		font-weight: 600;
	}
</style>
